import FirstStep from './first-step';
import SecondStep from './second-step';

export default {
  FirstStep,
  SecondStep,
};
